"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchRetry = void 0;
/* eslint-disable no-await-in-loop */
const wait_1 = require("./wait");
const fetchRetry = async (fetchFunction, options) => {
    const { retries, minTimeout, onFailedAttempt } = options;
    for (let attempt = 0; attempt <= retries; attempt += 1) {
        try {
            return await fetchFunction();
        }
        catch (err) {
            if (onFailedAttempt) {
                onFailedAttempt(err, attempt, retries - attempt);
            }
            if (attempt < retries) {
                await (0, wait_1.wait)(minTimeout * 2 ** attempt);
            }
            else {
                throw err;
            }
        }
    }
    throw new Error('Fetch retry failed');
};
exports.fetchRetry = fetchRetry;
